export const createPromptActivationHandler = (interactionDisabled, onPromptClick, prompt, pageType) => () => {
    if (interactionDisabled)
        return;
    onPromptClick(prompt, pageType);
};
//# sourceMappingURL=promptInteraction.js.map